import { Classification, ClassificationReason } from 'src/enums/classification';

import { TroubleReport } from './troubleReport';
import { ECU } from './ecu';
import { OffboardComponent } from './offboardComponent';
import { TestCaseAlternativeFailedReason } from './testCaseAlternativeFailedReason';

export class TestResult {
	testResultUid: string;

	vehicleName: string;

	vinNo: string;

	executionTimeTestRun: Date;

	executionTimeTestResult: Date;

	executedBy: string;

	result: string;

	resultComment: string;

	classification: Classification;

	classificationReason: ClassificationReason;

	classificationComment: string;

	testScriptUid: string;

	testScriptName: string;

	testScriptVersion: string;

	uc: string;

	uf: string;

	scn: string;

	failedReason: number;

	failedReasonText: string;

	failedBy: string;

	failedReasonComment: string;

	executionLocation: string;

	inputType: number;

	hide: boolean;

	troubleReports: TroubleReport[];

	resultText: string;

	errorText: string;

	ecus: ECU[];

	offboardComponents: OffboardComponent[];

	testCaseAlternativeFailedReasons: TestCaseAlternativeFailedReason[];

	positiveComment: string;

	negativeComment: string;

	// test result linked to
	testRunUid: string;

	testRunType: number;

	testCaseUid: string;

	testCaseItemNo: string;

	testCaseName: string;

	testCaseVersion: number;

	testSuiteUid: string;

	testSuiteItemNo: string;

	testSuiteName: string;

	testSuiteVersion: string;

	mainTestSuiteUid: string;

	mainTestSuiteItemNo: string;

	mainTestSuiteName: string;

	mainTestSuiteVersion: string;

	testSpecificationUid: string;

	testSpecificationName: string;

	testSpecificationVersion: string;

	testSpecificationItemNo: string;

	linkUid: string;
}

export class TestResultBase {
	testResultUid: string;

	executionTimeTestResult: Date;

	testRunUid: string;

	executionTimeTestRun: Date;

	result: string;

	testCaseUid: string;

	testCaseVersion: number;

	testCaseName: string;
}
